'use strict';

var utils = require('../utils');
var responsive = utils.responsive;

var keyboardAccessibility = require('base/components/keyboardAccessibility');

var clearSelection = function (element) {
    $(element).closest('.dropdown').children('.dropdown-menu').children('.top-category')
        .detach();
    $(element).closest('.dropdown.show').children('.nav-link').attr('aria-expanded', 'false');
    $(element).closest('.dropdown.show').children('.dropdown-menu').attr('aria-hidden', 'true');
    $(element).closest('.dropdown.show').removeClass('show');
    $('div.menu-group > ul.nav.navbar-nav > li.nav-item > a').attr('aria-hidden', 'false');
    $(element).closest('li').detach();
};

var clearSearchText = function () {
    $('input.form-control.search-field').val('');
}

var showPopularSearches = function () {
    $('.popular-searches-wrapper').removeClass('d-none');
    $('.suggestions-wrapper').empty();
}

module.exports = function () {
    var isDesktop = responsive.isLarge();

    var headerBannerStatus = window.sessionStorage.getItem('hide_header_banner');
    $('.header-banner .close').on('click', function () {
        $('.header-banner').addClass('d-none');
        window.sessionStorage.setItem('hide_header_banner', '1');
    });

    if (!headerBannerStatus || headerBannerStatus < 0) {
        $('.header-banner').removeClass('d-none');
    }

    var toggleBackground = function (on, closeFunction) {
        var close = typeof closeFunction === 'function'
            ? closeFunction
            : function () { $('.navbar .close-button').trigger('click'); };
        var $modalBg = $('.modal-background');
        if (on) {
            if (!$modalBg.is(':visible')) {
                // Ensure background/nav appear below header on med viewport.
                // TODO: Skip if sticky header (not currently implemented)
                window.scrollTo(0, 0);

                // Prevent page scroll.
                $('body').css('height', '100vh').css('overflow-y', 'hidden');
                $modalBg.addClass('modal-main-menu').show();
                window.setTimeout(function () {
                    $modalBg.addClass('active');
                }, 50);
            }

            $modalBg.off('click');
            $modalBg.on('click', close);
        } else {
            $modalBg.removeClass('active');
            window.setTimeout(function () {
                $modalBg.removeClass('modal-main-menu').hide();
                $('body').css('height', '').css('overflow-y', '');
                $modalBg.off('click');
            }, 500);
        }
    };

    var closeMainMenu = function (resetAccordions) {
        $('.menu-toggleable-left').removeClass('in');
        $('a.main-menu-toggler.active').removeClass('active');

        $('.navbar-toggler').focus();

        var mainMenu = $('.main-menu');
        mainMenu.removeClass('reveal').attr('aria-hidden', 'true');
        mainMenu.siblings().attr('aria-hidden', 'false');
        $('header').siblings().attr('aria-hidden', 'false');

        $('#search-menu .reset-button').trigger('click');

        if (resetAccordions) {
            mainMenu.find('.btn-link').each(function (i) {
                var btn = $(this);
                if ((
                    i === 0 && btn.hasClass('collapsed'))
                    || (i > 0 && !btn.hasClass('collapsed'))
                ) {
                    btn.trigger('click');
                }
            });
        }

        window.W3llpeople.activeMenuGroup = '';
    };

    keyboardAccessibility('.main-menu .nav-link, .main-menu .dropdown-link',
        {
            40: function (menuItem) { // down
                if (menuItem.hasClass('nav-item')) { // top level
                    $('.navbar-nav .show').removeClass('show')
                        .children('.dropdown-menu')
                        .removeClass('show');
                    menuItem.addClass('show').children('.dropdown-menu').addClass('show');
                    menuItem.find('ul > li > a')
                        .first()
                        .focus();
                } else {
                    menuItem.removeClass('show').children('.dropdown-menu').removeClass('show');
                    if (!(menuItem.next().length > 0)) { // if this is the last menuItem
                        menuItem.parent().parent().find('li > a') // set focus to the first menuitem
                            .first()
                            .focus();
                    } else {
                        menuItem.next().children().first().focus();
                    }
                }
            },
            39: function (menuItem) { // right
                if (menuItem.hasClass('nav-item')) { // top level
                    menuItem.removeClass('show').children('.dropdown-menu').removeClass('show');
                    $(this).attr('aria-expanded', 'false');
                    menuItem.next().children().first().focus();
                } else if (menuItem.hasClass('dropdown')) {
                    menuItem.addClass('show').children('.dropdown-menu').addClass('show');
                    $(this).attr('aria-expanded', 'true');
                    menuItem.find('ul > li > a')
                        .first()
                        .focus();
                }
            },
            38: function (menuItem) { // up
                if (menuItem.hasClass('nav-item')) { // top level
                    menuItem.removeClass('show').children('.dropdown-menu').removeClass('show');
                } else if (menuItem.prev().length === 0) { // first menuItem
                    menuItem.parent().parent().removeClass('show')
                        .children('.nav-link')
                        .attr('aria-expanded', 'false');
                    menuItem.parent().children().last().children() // set the focus to the last menuItem
                        .first()
                        .focus();
                } else {
                    menuItem.prev().children().first().focus();
                }
            },
            37: function (menuItem) { // left
                if (menuItem.hasClass('nav-item')) { // top level
                    menuItem.removeClass('show').children('.dropdown-menu').removeClass('show');
                    $(this).attr('aria-expanded', 'false');
                    menuItem.prev().children().first().focus();
                } else {
                    menuItem.closest('.show').removeClass('show')
                        .closest('li.show').removeClass('show')
                        .children()
                        .first()
                        .focus()
                        .attr('aria-expanded', 'false');
                }
            },
            27: function (menuItem) { // escape
                var parentMenu = menuItem.hasClass('show')
                    ? menuItem
                    : menuItem.closest('li.show');
                parentMenu.children('.show').removeClass('show');
                parentMenu.removeClass('show').children('.nav-link')
                    .attr('aria-expanded', 'false');
                parentMenu.children().first().focus();
            }
        },
        function () {
            return $(this).parent();
        });

    $('.dropdown:not(.disabled) [data-toggle="dropdown"]')
        .on('click', function (e) {
            if (!isDesktop(this)) {
                toggleBackground(true);
                // copy parent element into current UL
                var li = $('<li class="dropdown-item top-category" role="button"></li>');
                var link = $(this).clone().removeClass('dropdown-toggle')
                    .removeAttr('data-toggle')
                    .removeAttr('aria-expanded')
                    .attr('aria-haspopup', 'false');
                li.append(link);
                var closeMenu = $('<li class="nav-menu"></li>');
                closeMenu.append($('.close-menu').first().clone());
                $(this).parent().children('.dropdown-menu')
                    .prepend(li)
                    .prepend(closeMenu)
                    .attr('aria-hidden', 'false');
                // copy navigation menu into view
                $(this).parent().addClass('show');
                $(this).attr('aria-expanded', 'true');
                $(link).focus();
                $('div.menu-group > ul.nav.navbar-nav > li.nav-item > a').attr('aria-hidden', 'true');
                e.preventDefault();
            }
        })
        .on('mouseenter', function () {
            if (isDesktop(this)) {
                var eventElement = this;
                $('.navbar-nav > li').each(function () {
                    if (!$.contains(this, eventElement)) {
                        $(this).find('.show').each(function () {
                            clearSelection(this);
                        });
                        if ($(this).hasClass('show')) {
                            $(this).removeClass('show');
                            $(this).children('ul.dropdown-menu').removeClass('show');
                            $(this).children('.nav-link').attr('aria-expanded', 'false');
                        }
                    }
                });
                // need to close all the dropdowns that are not direct parent of current dropdown
                $(this).parent().addClass('show');
                $(this).siblings('.dropdown-menu').addClass('show');
                $(this).attr('aria-expanded', 'true');
            }
        })
        .parent()
        .on('mouseleave', function () {
            if (isDesktop(this)) {
                $(this).removeClass('show');
                $(this).children('.dropdown-menu').removeClass('show');
                $(this).children('.nav-link').attr('aria-expanded', 'false');
            }
        });

    $('.navbar>.close-menu>.close-button, .menu-group .close-button').on('click', function (e) {
        e.preventDefault();
        closeMainMenu(true);
        toggleBackground(false);
        clearSearchText();
        showPopularSearches();
    });

    $('.navbar-nav').on('click', '.back', function (e) {
        e.preventDefault();
        clearSelection(this);
    });

    $('.navbar-nav').on('click', '.close-button', function (e) {
        e.preventDefault();
        $('.navbar-nav').find('.top-category').detach();
        $('.navbar-nav').find('.nav-menu').detach();
        $('.navbar-nav').find('.show').removeClass('show');

        closeMainMenu(true);
        toggleBackground(false);
    });

    var openMainMenu = function () {
        var mainMenu = $('.main-menu');
        mainMenu.toggleClass('in');
        toggleBackground(true);
        mainMenu.attr('aria-hidden', 'false');
        mainMenu.siblings().attr('aria-hidden', 'true');
        $('header').siblings().attr('aria-hidden', 'true');

        window.setTimeout(function () {
            mainMenu.addClass('reveal');
        }, 500);
    };

    var openGroupMenu = function (menu) {
        var menuList = $('#menu-list');
        var searchMenu = $('#search-menu');
        var closeBtn = $('.menu-group .close-button');
        var activeMenu = menu;
        if (activeMenu && activeMenu !== 'all') {
            // If this is the account menu we want to keep the
            // utility links as well
            if (activeMenu === '#account-menu') {
                activeMenu += ', #utility-menu';
            }
            // Show hide search menu
            // TODO: Will change with search task.
            // Did this to have it be usable until then
            if (activeMenu === '#search-menu') {
                searchMenu.show();
                closeBtn.hide();
            } else {
                searchMenu.hide();
                closeBtn.show();
            }

            // Hide other sub-menus
            menuList.find('> li').not(activeMenu).hide();

            // Show sub-menu
            menuList.find(activeMenu)
                .show()
                .find('.card-header button.collapsed')
                .trigger('click');
        } else {
            menuList.find('> li').show();
            searchMenu.show();
            closeBtn.hide();
        }
        $('a.main-menu-toggler')
            .removeClass('active')
            .filter('[data-menu="' + menu + '"]')
            .addClass('active');

        window.W3llpeople = {
            activeMenuGroup: activeMenu || 'all'
        };
    };

    var toggleMenus = function (menu, toggleClose) {
        var mainMenu = $('.main-menu');

        if (window.W3llpeople.activeMenuGroup.indexOf(menu) === -1) {
            if (mainMenu.hasClass('in')) {
                closeMainMenu();
                openMainMenu();
            } else {
                openMainMenu();
            }
            openGroupMenu(menu);
        } else if (toggleClose) {
            closeMainMenu(true);
            toggleBackground(false);
        }
    };

    $('.main-menu-toggler').on('click', function (e) {
        e.preventDefault();
        var mainMenu = $('.main-menu');
        var menu = $(this).data('menu');

        mainMenu.removeClass('menu-toggleable-right menu-toggleable-right-top');

        if (['all', '#account-menu'].some(function (m) { return menu === m; })) {
            mainMenu.addClass('menu-toggleable-right');
        } else if (menu === '#search-menu') {
            mainMenu.addClass('menu-toggleable-right-top');
        }

        window.setTimeout(function () {
            toggleMenus(menu || '', true);
        }, 50);
    });

    keyboardAccessibility('.js-user-menu-desktop',
        {
            40: function ($popover) { // down
                if ($popover.children('a').first().is(':focus')) {
                    $popover.next().children().first().focus();
                } else {
                    $popover.children('a').first().focus();
                }
            },
            38: function ($popover) { // up
                if ($popover.children('a').first().is(':focus')) {
                    $(this).focus();
                    $popover.removeClass('show');
                } else {
                    $popover.children('a').first().focus();
                }
            },
            27: function () { // escape
                $('.js-user-menu-desktop .popover').removeClass('show');
                $('.user').attr('aria-expanded', 'false');
            },
            9: function () { // tab
                $('.js-user-menu-desktop .popover').removeClass('show');
                $('.user').attr('aria-expanded', 'false');
            }
        },
        function () {
            var $popover = $('.user .popover li.nav-item');
            return $popover;
        });

    $('.js-user-menu-desktop').on('mouseenter focusin', function () {
        if ($('.js-user-menu-desktop .popover').length > 0) {
            $('.js-user-menu-desktop .popover').addClass('show');
            $('.user').attr('aria-expanded', 'true');
        }
    });

    $('.js-user-menu-desktop').on('mouseleave', function () {
        $('.js-user-menu-desktop .popover').removeClass('show');
        $('.user').attr('aria-expanded', 'false');
    });

    $('body').on('click', '#myaccount', function (event) {
        event.preventDefault();
    });

    var accordions = $('.accordion');
    var accordionButtons = accordions.find('.card-header button');
    accordions.find('button:not(.collapsed)').parents('.accordion').addClass('active');
    accordions.on('click', 'button', function () {
        var btn = $(this);
        var menuGroup = btn.parents('.accordion');
        accordionButtons.removeClass('active');
        if (btn.hasClass('collapsed')) {
            btn.addClass('active');
            menuGroup.addClass('active');
        } else {
            btn.removeClass('active');
            menuGroup.removeClass('active');
        }
    });

    window.W3llpeople = {
        activeMenuGroup: ''
    };
};
